<template>
  <div>
    <b-container style="position: relative;" class="builders pt-5">
      <div class="textBuilders">
        <b-row>
          <b-col
            cols="12"
            offset="0"
            md="10"
            offset-md="1"
            lg="8"
            offset-lg="2"
          >
            <h1>
              FOR THOSE WHO VALUE...<br class="d-none d-sm-block">
              A TRUSTED BUILDER TEAM
            </h1>
          </b-col>
          <b-col
            cols="12"
            offset="0"
            md="6"
            offset-md="0"
            lg="4"
            offset-lg="2"
          >
            <b-img class="logo" src="/img/fernbrook-c.png" fluid />
            <p>
              Fernbrook Homes is one of Canada’s leading
              builders and is widely recognized for their
              outstanding commitment to creating distinctive
              communities. With a keen natural
              understanding of what makes a community a
              preferred place to live, Fernbrook has an
              exceptional reputation for architectural
              integrity, classic design, and outstanding
              customer service.
            </p>
            <p>
              Fernbrook is proud of their commitment to
              complete customer satisfaction and strives to
              offer the finest after-sales customer service in
              the industry. Come discover a lifetime of
              satisfaction awaiting you here.
            </p>
          </b-col>
          <b-col cols="12" md="6" lg="4">
            <b-img class="logo" src="/img/tiffany-c.png" fluid />
            <p>
              At Tiffany Park Homes we believe we’re earning our
              customer’s trust and respect with every home that we build.
              From our beginnings as a small family business, our
              commitment to quality construction and customer service
              has helped us to grow into one of the most reputable
              homebuilders in the GTA, with an enviable reputation of
              thousands of fine homes built over 20 years.
            </p>
            <p>
              We believe that the ultimate proof of Tiffany Park
              homeowner satisfaction can be seen in the many referrals of
              friends and relatives made by Tiffany Park homeowners over
              the years. We also believe that the fact that many of our
              new homebuyers are previous Tiffany Park homeowners
              demonstrates that once you’ve experienced the exceptional
              quality of a Tiffany Park home, you simply won’t want to live
              in a home built by anybody else.
            </p>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<style lang="scss">
.builders{
  margin-bottom: 20px;
  .textBuilders{
      text-align: left;
      @media screen and (max-width: 768px){
        text-align: center;
      }
      background-color: #F1F1F2;
      h1{
        padding-top: 25px;
        font-weight: normal;
        font-size: 40px;
        @media screen and (max-width: 768px){
          font-size: 25px;
        }
        color: #F05B2D;
      }
      p{
        font-size: 14px;
        @media screen and (max-width: 768px){
          padding: 0px 15px;
        }
      }
      .logo{
        width: 212px;
        margin: 10px 40px 11px 0px;
        @media screen and (max-width: 768px){
          width: 200px;
          margin: 15px auto;
        }
      }
  }
}

</style>
